import type { Identifier } from "ra-core";

/** A new task has an owner and no deadline until the user picks one. */
export function newTaskRecord(
  salesId: Identifier,
  contactId?: Identifier | null,
) {
  return {
    type: "none" as const,
    contact_id: contactId ?? undefined,
    sales_id: salesId,
  };
}
